<template>
  <Header style="position:fixed; bottom:0px; width:100%; z-index:999999;">
    <div class="header-buttons">
      <Button class="header-big-button" type="text" icon="ios-desktop" size="large" @click="$emit('visibilityToggle', 'Slide Deck')">Slide Deck</Button>
      <Button class="header-big-button" type="text" icon="ios-help-circle" size="large" @click="$emit('visibilityToggle', 'Questions')">Questions</Button>
      <Button class="header-big-button" type="text" icon="ios-contacts" size="large" @click="$emit('visibilityToggle', 'Participants')">Participants</Button>
      <Button class="header-big-button" type="text" icon="ios-checkmark-circle" size="large" @click="$emit('visibilityToggle', 'Q&A Moderation')">Q&A Moderation</Button>
      <Button class="header-big-button" type="text" icon="ios-chatbubbles" size="large" @click="$emit('visibilityToggle', 'Team Chat')">Team Chat</Button>
    </div>
  </Header>
</template>
<script>
export default {

}
</script>
<style lang="less">
.ivu-layout-header{
  background: #fff !important;
}

.header-buttons{
  display: flex;
  width: fit-content;
  margin:auto;
}
.header-big-button{
  font-size:12px;
  padding: 11px 8px 8px !important;
  .ivu-icon{
    font-size:24px;
    display:block;
    line-height:24px !important;
  }
  span{
    display:block;
    margin:0;
    font-size:12px;
  }
}
</style>
